
import Async from "../../components/Async";

import { BusinessCenter } from "@material-ui/icons";

const AuthGuard = Async(() => import("../auth.guard"));

const PackageView = Async(() => import('../../pages/financial/package'));
const TransactionsView = Async(() => import('../../pages/financial/transactions'));
const FinancialFaciliterInvoices = Async(() => import('../../pages/financial/faciliters/faciliter.invoice'));
const CustomerPackagesView = Async(() => import('../../pages/financial/customer.packages'));

const routes = {
    financial: {
        id: 'Financeiro',
        path: '/financial/packages',
        icon: <BusinessCenter />,
        children: [
            {
                id: 'packages',
                path: '/financial/packages',
                name: 'Pacotes',
                component: PackageView,
            },
            {
                id: 'transactions',
                path: '/financial/transactions',
                name: 'Transações',
                component: TransactionsView,
            },
            {
                id: 'invoices',
                path: '/financial/invoices',
                name: 'Faturas Faciliters',
                component: FinancialFaciliterInvoices,
            },
        ],
        roles: ['admin', 'financial', 'seller'],
        component: null,
    },
    customerPackages: {
        id: 'customerPackages',
        path: '/financial/packages/customer/:customerId',
        component: CustomerPackagesView,
        guard: AuthGuard,
        roles: ['admin', 'financial', 'seller'],
        disabledMenu: true,
    },
}

const pages = Object.values(routes);

export default {
    routes,
    pages
}